import axios from 'axios'
let baseUrl = ''
    // 请求拦截
axios.interceptors.request.use((config) => {
        return config
    }, error => {
        return Promise.reject(error)
    })
    // 响应拦截
axios.interceptors.response.use(res => {
    return res.data
}, error => {
    return Promise.reject(error)
})

function $get(url, data = {}) {
    return axios.get(url, {
        params: data
    })
}

function $post(url, data = {}) {
    return axios.post(url, data)
}
class Services {
    project = {
        share: data => $get('/api/v1/jsParam', data) // 分享
    }
}
export default Services


// WEBPACK FOOTER //
// ./src/api/index.js